// src/screens/Reconcile/ReconcileAdjustSalesTax.js
import React, { useContext } from 'react';
import CountContext from '../../context/CountContext.js';

export default function ReconcileAdjustSalesTax({ onNext, onBack }) {
  const { state, dispatch } = useContext(CountContext);
  const { report, tax, vendorPayouts, salesAdjusted } = state;
  const giftPaymentWhole = Math.floor(report.giftCardPayment || 0);
  // Isolate redeemed gift-card cents to add back
  const giftPaymentCents = Number(((report.giftCardPayment || 0) % 1).toFixed(2));


  // 1) Verify old tax
  const reportedSales = Number((report.totalSales - report.giftCardSold).toFixed(2));
  const reportedTax = report.totalTax;
  const baseSales = Number((reportedSales - reportedTax).toFixed(2));
  const expectedOldTax = Math.floor(baseSales * tax.salesRate * 100) / 100;
  const taxMatch = expectedOldTax === reportedTax;
  const taxDiff = reportedTax - expectedOldTax;
  const canProceedOldTax = Math.abs(taxDiff) <= 0.10;

  // 2) Compute suggested new sales based on credit-card cents and vendor payouts
  // **Start from the net “effectiveSales”** (totalSales minus giftCardSold)
  const creditCents = Number((report.totalCharges % 1).toFixed(2));
  const vendorTotal = vendorPayouts.reduce((sum, v) => sum + (v.amount || 0), 0);
  const vendorCents = Number((vendorTotal % 1).toFixed(2));

  const combinedCents = Number((creditCents + vendorCents).toFixed(2));
  const rawAnchor = Math.floor(reportedSales - combinedCents);
  const suggestedSales = Number((rawAnchor + combinedCents + giftPaymentCents).toFixed(2));
  // 3) Recompute tax on suggested sales
  const newBaseSales = Number((suggestedSales / (1 + tax.salesRate)).toFixed(2));
  const newTax = Number((suggestedSales - newBaseSales).toFixed(2));
  // 🔍 Debug log

  const applyAdjustment = () => {
    dispatch({
      type: 'APPLY_REPORT_ADJUSTMENT',
      payload: { adjustedTotal: suggestedSales, adjustedTax: newTax }
    });
    onNext();
  };

  return (
    <div className="p-4 max-w-md mx-auto bg-white rounded-2xl shadow-lg space-y-6">
      <h2 className="text-2xl font-bold">Adjust Sales & Tax</h2>

      <section className="space-y-2">
        <h3 className="text-lg font-semibold">Original POS vs. Expected Tax</h3>
        <div>Reported Sales: ${reportedSales.toFixed(2)}</div>
        <div>Reported Tax: ${reportedTax.toFixed(2)}</div>
        <div>Expected Tax @ {(tax.salesRate * 100).toFixed(2)}%: ${expectedOldTax.toFixed(2)}</div>
        {!taxMatch && (
          <div className="text-red-600">
            ⚠ Tax and sales mismatch by ${Math.abs(taxDiff).toFixed(2)}.
            Enter any unredeemed gift-card sales above to adjust.
          </div>
        )}
      </section>

      <section className="space-y-2">
        <h3 className="text-lg font-semibold">Suggested Adjustment</h3>
        <div>Suggested Sales: ${suggestedSales.toFixed(2)}</div>
        <div>New Tax @ {(tax.salesRate * 100).toFixed(2)}%: ${newTax.toFixed(2)}</div>
      </section>


      <div className="flex justify-between">
        <button onClick={onBack} className="px-4 py-2 bg-gray-300 rounded">
          Back
        </button>
        {!salesAdjusted ? (
          <button
            onClick={applyAdjustment}
            disabled={!canProceedOldTax}
            className={`px-4 py-2 rounded text-white ${canProceedOldTax ? 'bg-blue-500 hover:bg-blue-600' : 'bg-gray-400 cursor-not-allowed'
              }`}
          >
            Apply New Sales & Tax
          </button>
        ) : (
          <button
            onClick={onNext}
            className="px-4 py-2 bg-green-500 text-white rounded"
          >
            Continue
          </button>
        )}
      </div>
    </div>
  );
}
